import { IWebsite } from '@/app/[locale]/_store/types'
import { Avatar } from '@/components/ui/avatar'
import { Button, HStack, Image } from '@chakra-ui/react'

export default function Websites({ websites }: { websites: IWebsite[] }) {
  return (
    <HStack
      gap={3}
      pl={{ base: 4, lg: 0 }}
      mb={{ base: 4, lg: 0 }}
      alignItems='end'
      w='full'
      overflowX='scroll'
      style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
      }}
    >
      {websites?.map((web) => (
        <Button
          gap={2}
          py={1}
          key={web?.brand_name + web?.url}
          h={8}
          bg='white'
          fontWeight={600}
          mb={web?.url === '/' ? 0 : { base: '0', lg: '7px' }}
          borderRadius={web?.url === '/' ? '14px 14px 0 0' : 14}
          onClick={() => {
            const href = web.url.match(/^https?:\/\//)
              ? web.url
              : `https://${web.url}`
            window.open(href)
          }}
          variant={{ base: 'outline', lg: 'subtle' }}
          overflow='hidden'
          minW='100px'
        >
          {web?.logo ? (
            <Image
              height='full'
              src={
                web?.logo
                  ? web?.logo.includes('https')
                    ? web?.logo
                    : `${process.env.BASE_URL}${web?.logo}`
                  : ''
              }
              alt='logo'
            />
          ) : (
            <Avatar
              name={web?.brand_name || 'Brand'}
              w={'32px'}
              height={'32px'}
              shape={'square'}
              rounded={12}
              size={'lg'}
            />
          )}
          {web?.brand_name}
        </Button>
      ))}
    </HStack>
  )
}
